// src/app/views/pages_predict_admin/score_stat/rtPrAdScoreStat.js
import Loadable from "app/components/Loadable";
import { lazy } from "react";
import { EXAM_TYPES } from "app/types/examTypes";

const ScoreStat_LEET = Loadable(lazy(() => import("./ScoreStat_LEET")));
const ScoreStat_G5 = Loadable(lazy(() => import("./ScoreStat_G5")));
const ScoreStat_G7 = Loadable(lazy(() => import("./ScoreStat_G7")));

const rtPrAdScoreStat = [
  { path: `pre/${EXAM_TYPES.LEET.rid_cd_ext}/score-stat`, element: <ScoreStat_LEET /> },
  { path: `pre/${EXAM_TYPES.G5.rid_cd_ext}/score-stat`, element: <ScoreStat_G5 /> },
  { path: `pre/${EXAM_TYPES.G7.rid_cd_ext}/score-stat`, element: <ScoreStat_G7 /> },
];
export default rtPrAdScoreStat;
